import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { ShiftOperationsService } from '@wilson/non-domain-specific/shift-helpers/core';
import { SetDemarcatorRange } from '@wilson/shift-timeline/state';
import { ShiftMultiSelectHelperService } from '@wilson/shift-timeline/assignments-gantt-chart';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'wilson-shift-form-view-button',
  templateUrl: './shift-form-view-button.component.html',
  styleUrls: ['./shift-form-view-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, NzButtonModule, FontAwesomeModule],
})
export class ShiftFormViewButtonComponent {
  private readonly shiftOperationsService = inject(ShiftOperationsService);
  private readonly store = inject(Store);
  private readonly shiftMultiSelectHelperService = inject(
    ShiftMultiSelectHelperService,
  );

  readonly faUpRightFromSquare = faUpRightFromSquare;

  @Input() disabled = false;
  @Input() shiftId?: string = undefined;
  @Input() isFormPristine = false;

  navigateToShiftDetails(): void {
    if (this.shiftId) {
      const route = `/shifts/${this.shiftId}`;
      if (!this.isFormPristine) {
        this.shiftOperationsService.confirmNavigateAway(() => {
          window.open(route, '_blank');
          this.store.dispatch([new SetDemarcatorRange([])]);
          this.shiftMultiSelectHelperService.clearSelection();
        });
      } else {
        window.open(route, '_blank');
      }
    }
  }
}
